import React from 'react';
import ModalContainer from './ModalContainer';

export const SideNavModal = ({ children, contentDirection, onClose, opacity }) => {
  return (
    <ModalContainer contentDirection={contentDirection} onClose={onClose} opacity={opacity}>
      {children}
    </ModalContainer>
  );
};
